import { render, staticRenderFns } from "./LandingStats.vue?vue&type=template&id=572cdfa2&scoped=true&"
import script from "./LandingStats.vue?vue&type=script&lang=js&"
export * from "./LandingStats.vue?vue&type=script&lang=js&"
import style0 from "./LandingStats.vue?vue&type=style&index=0&id=572cdfa2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572cdfa2",
  null
  
)

export default component.exports